import React, { Component } from 'react';
import VerificationStatusDetails from './VerificationStatusDetails';
import { withTranslation } from 'react-i18next';
import UserData from '../clientAdmin/socialIntelligence/UserData';
import VerificationEvidenceShow from './VerificationEvidenceShow';
import { RestDataSource } from 'utils/RestDataSource';
import { restbaseurl } from 'globals/constants';
import UserInfo from 'models/UserInfo';
import BTSnackbar from '../globals/uicomps/BTSnackbar';
import { LoadingSpinner } from 'utils/LoadingSpinner';
import { JsonViewer } from 'json-viewer-react';


class VerificationStatusDetailsHeader extends Component {

     constructor(props) {
          super(props);
          this.state = {
               isRetryHidden: false,
               showSnackMessage: false,
               snackMessage: '',
               snackStatus: '',
               otpValue: "",
               aadhaarClientId: "",
               loading: false,
               isOTPProcessCompleted: false,
               additionalJSONInfo: "",
               additionalInfo: null
          };
     }

     fetchRetry = () => {
          this.setState({ isRetryHidden: true });
          const requestObj = { "userId": UserInfo.getUserid(), "caseId": this.props.caseId, "code": this.props.code, "caseVerifiDetailId": this.props.caseVerifiDetailId };

          this.applicantCaseRetry = new RestDataSource(
               `${restbaseurl}/applicantCase/retry`
          );
          this.applicantCaseRetry.GetData(
               data => {
                    this.setState({ isRetryHidden: true });
               },
               requestObj,
               "POST"
          );
     }
     fetchAddInfo = () => {


          const validateAndGenerateData = (recData) => {
               try {

                    if (Array.isArray(recData) && recData.length > 0) {
                         return { type: "json", data: recData[0] }
                    } else if (typeof recData === "object" && recData !== null) {
                         return { type: "json", data: recData }
                    } else {
                         return { type: "string", data: recData };
                    }

               } catch (e) {
                    return { type: "string", data: recData }; // Not valid JSON, just a plain string
               }
          }

          // const addInfo = data.Info;
          // const addInfo = { "statusCode": 201, "statusMsg": "Report is Ready", "idc": 1, "name": "Anand D", "addresses": [{ "address": "Chennai" }], "matchedCaseDetails": [], "report": "Green", "reportUrl": "https://firhtml.s3.us-west-2.amazonaws.com/06fa5c91138452048b9c371d1a44205b_altum.pdf", "job_name": "pyramidion_individual_crime_mafa:26-04-2025 10:15", "dateOfVerification": "2025-04-26T12:06:06.640Z" };
          // const addInfo = [{"action":"verify_with_source","completed_at":"2025-02-06T10:33:18+05:30","created_at":"2025-02-06T05:03:02+05:30","group_id":"392044a0-4d29-44fc-89ab-29e6fcc96af3","purged_at":"2025-02-13T10:33:18+05:30","request_id":"a8fbd988-b964-485a-9372-682a7bec68cd","result":{},"status":"completed","task_id":"749b30a4-a776-4e67-972b-87c432b48965","type":"ind_court_record"}];
          // const addInfo = "Testing the string"
          // const validateObject = validateAndGenerateData(addInfo);


          // this.setState({
          //      additionalInfo: validateObject,
          //      loading: false
          // });
          // return
          const userId = UserInfo.getUserid()

          const getAdditionalInfo = new RestDataSource(`${restbaseurl}/applicantCase/getAdditionalInfo`);
          this.setState({ loading: true }, () => {
               getAdditionalInfo.GetData(
                    (data) => {
                         if (data.status === true) {
                              this.setState({
                                   additionalInfo: validateAndGenerateData(data.info),
                                   loading: false
                              });
                         } else {
                              this.setState({
                                   showSnackMessage: true,
                                   snackMessage: "Additional Info Not Available",
                                   snackStatus: 'danger',
                                   loading: false
                              });
                         }
                    },
                    {
                         "userId": userId, "caseId": this.props.caseId, "code": this.props.code, "caseVerifiDetailId": this.props.caseVerifiDetailId

                    },
                    'POST',
               );
          });
     }


     // Commented out for future use - Aadhar OTP generation functionality
     // fetchOTP = e => {
     //      const userId = UserInfo.getUserid()

     //      const getAadhaarOtp = new RestDataSource(`${restbaseurl}/applicantCase/getAadhaarOtp`);
     //      this.setState({ loading: true }, () => {
     //           getAadhaarOtp.GetData(
     //                (data) => {
     //                     if (data.status === true) {
     //                          this.setState({
     //                               showSnackMessage: true,
     //                               snackMessage: data.message,
     //                               snackStatus: 'success',
     //                               aadhaarClientId: data.aadhaarClientId,
     //                               loading: false
     //                          });
     //                     } else {
     //                          this.setState({
     //                               showSnackMessage: true,
     //                               snackMessage: data.message,
     //                               snackStatus: 'danger',
     //                               aadhaarClientId: "",
     //                               loading: false
     //                          });
     //                     }
     //                },
     //                {
     //                     "userId": userId, "caseId": this.props.caseId, "code": this.props.code, "caseVerifiDetailId": this.props.caseVerifiDetailId

     //                },
     //                'POST',
     //           );
     //      });
     // }

     /**
      * Submit Aadhaar OTP for verification
      * After successful submission, refreshes the verification status
      * Commented out for future use - Aadhar OTP submission functionality
      */
     // onSendOTP = e => {
     //      const userId = UserInfo.getUserid();
     //      const verifyOTPReq = new RestDataSource(`${restbaseurl}/applicantCase/submitAadhaarOtp`)
     //      this.setState({ loading: true }, async () => {
     //           verifyOTPReq.GetData(
     //                data => {
     //                     this.setState({ loading: false })
     //                     if (data.status === true) {
     //                          this.setState({
     //                               showSnackMessage: true,
     //                               snackMessage: data.message,
     //                               snackStatus: 'success',
     //                               loading: false,
     //                               otpValue: "",
     //                               aadhaarClientId: "",
     //                               isOTPProcessCompleted: true
     //                          });
     //                          
     //                          // Refresh verification status data after successful OTP submission
     //                          // Add a small delay to ensure backend processing is complete
     //                          setTimeout(() => {
     //                               if (this.props.cbRender) {
     //                                    this.props.cbRender();
     //                               }
     //                          }, 1000);
     //                     } else {
     //                          this.setState({
     //                               showSnackMessage: true,
     //                               snackMessage: data.message,
     //                               snackStatus: 'danger',
     //                               loading: false
     //                          });
     //                     }
     //                },
     //                {
     //                     "userId": userId, "caseId": this.props.caseId, "code": this.props.code, "caseVerifiDetailId": this.props.caseVerifiDetailId
     //                     , "OTP": this.state.otpValue, aadhaarClientId: this.state.aadhaarClientId
     //                },
     //                "POST"
     //           );
     //      })
     // }
     hideSnackbar = () => {
          this.setState({ showSnackMessage: false, snackMessage: '', snackStatus: '' });
     }

     onOTPChange = (e) => {
          this.setState({ otpValue: e.target.value })
     }

     render = () => {

          const { t } = this.props;
          let { vendorOptions } = this.props;
          let elements;
          let evidenceList = this.props.evidenceList;
          let isEvidencePresent = evidenceList.length > 0 ? true : false;
          let isRetry = this.props.additionalInfo && this.props.additionalInfo.retry;
          let addiInfo = this.props.additionalInfo && this.props.additionalInfo.addiInfo;
          let showOtp = this.props.additionalInfo && this.props.additionalInfo.showOtp;
          if (this.props.typeMap['VerificationType'] !== 'Social Media Check') {
               elements = Object.keys(this.props.dataObj).map(data => (
                    <VerificationStatusDetails data={data} key={data + Math.random()} obj={this.props.dataObj} caseId={this.props.caseId} verificationType={this.props.typeMap['VerificationType']} vendorDetails={this.props.vendorDetails} addressList={this.props.dataObj['Address List']} address={this.props.dataObj['Address']} cbRender={this.props.cbRender} vendorOptions={vendorOptions} />
               ));
          }
          let evidence
          if (isEvidencePresent === true) {
               console.log("isEvidencePresent", isEvidencePresent)
               evidence = evidenceList.map(data =>
                    <VerificationEvidenceShow value={data} key={data} />
               )
          }
          return (
               <>
                    {
                         <div className="deep-track">
                              <div className="title">
                                   <div className="check-title">{t(this.props.typeMap['VerificationType'])}</div>
                                   <svg className="close-deep-track" onClick={() => { this.props.hideDeepTrack() }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <path d="M9.7,104l5.128-5.128,1.058-1.058a.4.4,0,0,0,0-.566l-1.132-1.132a.4.4,0,0,0-.566,0L8,102.3,1.815,96.117a.4.4,0,0,0-.566,0L.117,97.249a.4.4,0,0,0,0,.566L6.3,104,.117,110.186a.4.4,0,0,0,0,.566l1.132,1.132a.4.4,0,0,0,.566,0L8,105.7l5.128,5.128,1.058,1.058a.4.4,0,0,0,.566,0l1.132-1.132a.4.4,0,0,0,0-.566Z" transform="translate(4 -92)"></path>
                                   </svg>
                              </div>
                              <div className="content">
                                   {this.state.loading ? <LoadingSpinner showBg="true"/> : this.props.typeMap['VerificationType'] === 'Social Media Check' ?
                                        <UserData showSearchPage={false} userData={this.props.dataObj.userDataJson} /> :

                                        <React.Fragment>
                                             {
                                                  this.state.showSnackMessage ? <BTSnackbar msg={this.state.snackMessage} status={this.state.snackStatus} time="1500" onHide={this.hideSnackbar} /> : ''
                                             }
                                             <div className="case-check-details">
                                                  <div className="sub-heading1">
                                                       {t(this.props.typeMap['Verification'])}
                                                  </div>
                                                  <div className="clr20"></div>
                                                  <div className="row">
                                                       {elements}
                                                  </div>
                                             </div>
                                             <br />
                                             <br />
                                             {addiInfo &&
                                                  <button className="btn btn_primary ml10" onClick={this.fetchAddInfo}>Add Info</button>
                                             }
                                             {isRetry && !this.state.isRetryHidden ?
                                                  <button className="btn btn_primary ml10" onClick={this.fetchRetry}>Retry</button>
                                                  : this.state.isRetryHidden ? <button disabled={true} className="btn btn_primary ml10" >Retry</button> : ''
                                             }
                                             {/* Commented out for future use - Aadhar OTP UI elements */}
                                             {/* {
                                                  (showOtp && !this.state.isOTPProcessCompleted) ? this.state.aadhaarClientId === "" ?
                                                       <button className="btn btn_primary ml10" onClick={this.fetchOTP}>Get OTP</button> :
                                                       <div className='user-search' style={{ width: "18%" }}>
                                                            <input placeholder='Enter OTP' type="number" className="form-control input-empty" value={this.state.otpValue} onChange={this.onOTPChange} />

                                                            <br /><button className="btn btn_primary" onClick={this.onSendOTP}>Send OTP</button>

                                                       </div> : null
                                             } */}
                                             <br />
                                             <br />

                                             {
                                                addiInfo && <> {this.state.additionalInfo && <>{this.state.additionalInfo.type === "json" ?
                                                       <JsonViewer json={this.state.additionalInfo.data} i18nIsDynamicList={false} 
                                                       /> :<div className='sub-heading1'>Additional Info: <div className='smallfont'>{ this.state.additionalInfo.data}</div></div>}</>}</>
                                             }

                                             {isEvidencePresent ?
                                                  <div className="container">
                                                       <div className="row">
                                                            {evidence}
                                                       </div>
                                                  </div>
                                                  : ''
                                             }


                                        </React.Fragment>
                                   }
                              </div>
                         </div>
                    }
               </>

          );
     }
}
export default withTranslation('translations')(VerificationStatusDetailsHeader);
